export enum PAGES {
	HOME = 'sdui-admin',
}

/**
 * SDUI Admin's Module Federation remote: its federation name, and where Engine serves
 * its manifest from — Engine's own bucket, under remotes/sdui-admin/, which
 * motorway/mw-sdui-admin's deploy workflow writes to.
 *
 * The manifest's URL never changes, so the deploy must upload mf-manifest.json and
 * remoteEntry.js with `Cache-Control: no-cache`; everything they point at is fingerprinted.
 */
export const REMOTE = {
	NAME: 'sdui_admin',
	MANIFEST_PATH: '/remotes/sdui-admin/mf-manifest.json',
} as const;
